// extracted by mini-css-extract-plugin
module.exports = {"row":"styles-module--row--2Qdc9"};